class MmgsmSocialProof extends HTMLElement {
  connectedCallback() {
    if (this._reparented) return;

    const productId = this.dataset.productId;
    if (!productId) return;

    // El editor de temas puede volver a renderizar la sección (ej. al tocar
    // otro bloque) e insertar una instancia nueva mientras la anterior sigue
    // viva en <body>; si pasa, saca la vieja para no duplicar el aviso.
    document.querySelectorAll('mmgsm-social-proof[data-mmgsm-active]').forEach((el) => {
      if (el !== this) el.remove();
    });

    this.probability = Number(this.dataset.probability || 55) / 100;
    this.min = Number(this.dataset.min || 2);
    this.max = Math.max(this.min, Number(this.dataset.max || 9));
    this.rerollMs = Number(this.dataset.rerollMs || 20 * 60 * 1000);
    this.messageTemplate = this.dataset.message || '{count} personas están viendo este producto';
    this.storageKey = `mmgsm_sp_${productId}`;

    const state = this.loadOrRollState();
    if (!state.show) return;

    this.count = state.count;

    // Se reparenta a <body> para que position:fixed quede anclado de verdad
    // al viewport, sin depender de que ningún ancestro del tema (secciones
    // con transform/contain) rompa el fixed positioning. Mover el nodo
    // dispara disconnectedCallback + connectedCallback de nuevo; _reparented
    // corta ese segundo pase para no repetir el sorteo de estado.
    this._reparented = true;
    this.setAttribute('data-mmgsm-active', '');
    document.body.appendChild(this);

    this.render();
    this._driftTimer = setInterval(() => this.drift(), 45000);
  }

  disconnectedCallback() {
    clearInterval(this._driftTimer);
  }

  loadOrRollState() {
    const now = Date.now();
    let state = null;
    try {
      state = JSON.parse(sessionStorage.getItem(this.storageKey));
    } catch (e) {
      state = null;
    }

    if (!state || now - state.rolledAt > this.rerollMs) {
      const show = Math.random() < this.probability;
      state = {
        show,
        count: show ? this.randomCount() : 0,
        rolledAt: now,
      };
      this.saveState(state);
    }

    return state;
  }

  saveState(state) {
    sessionStorage.setItem(this.storageKey, JSON.stringify(state));
  }

  randomCount() {
    return Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
  }

  drift() {
    const delta = Math.random() < 0.5 ? -1 : 1;
    this.count = Math.min(this.max, Math.max(this.min, this.count + delta));
    this.saveState({ show: true, count: this.count, rolledAt: Date.now() });
    this.updateText();
  }

  render() {
    this.innerHTML = `
      <p class="mmgsm-social-proof__text">
        <span class="mmgsm-social-proof__icon" aria-hidden="true">${this.iconSvg()}</span>
        <span data-mmgsm-sp-text></span>
      </p>
    `;
    this.updateText();
  }

  updateText() {
    const el = this.querySelector('[data-mmgsm-sp-text]');
    if (el) el.textContent = this.messageTemplate.replace('{count}', this.count);
  }

  iconSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" fill="none" width="10" height="10"><circle cx="7.5" cy="7.5" r="7.5" fill="currentColor"/><circle cx="7.5" cy="7.5" r="5" fill="currentColor" stroke="#FFF"/></svg>';
  }
}

if (!customElements.get('mmgsm-social-proof')) {
  customElements.define('mmgsm-social-proof', MmgsmSocialProof);
}
